// @flow

import React, { type ComponentType } from 'react';

const withPdbIdMapping = <Props: { pdb_id: string }>(
  WrappedComponent: ComponentType<$Diff<Props, {| pdb_id: string | void |}>>,
): ComponentType<$Exact<$Diff<Props, { pdbId: string | void }>>> => (
    ({ pdb_id, ...rest }) => (
      <WrappedComponent pdbId={pdb_id} {...rest} />
    )
  );

export default withPdbIdMapping;
